export const CART_REG_STATUS = [
  {
    values: '',
    label: 'Tất cả',
  },
  {
    values: '0',
    label: 'Mới',
  },
  {
    values: '1',
    label: 'Đã đăng ký',
  },
  {
    values: '2',
    label: 'Chưa đăng ký',
  },
];
